import {SetSessionStorage} from '../core/functions';
import {InitSuperMenu} from './superMenu';
import {getContainer} from "./getContainer";
//import {loadMiniCartForExitIntent} from "./exitIntent";
import {InitCollapse} from './collapse';
import {InitSwitches} from './switch';
import {InitModals} from './modal';
import {InitTooltips} from './tooltip';
import InitDataHref from './dataHref';

export const EffectSpeed = 150;

/**
 * Toon stock error melding bij het product
 * @param {string} strMessage - De foutmelding tekst
 * @param {jQuery} objTargetElement - Het element waar de melding bij getoond moet worden
 */
const showStockError = (strMessage, objTargetElement) => {
    var objDivStockError = $('<div class=\'stock-error-message\'></div>');
    objDivStockError.html(strMessage);

    //--Zoek het product card element
    var objProductCard = objTargetElement.closest('.product-card, .product-index, .card');
    var blnIsOverview = objProductCard.length > 0;

    //--Stijl aanpassen op basis van context (overzicht = kleinere font)
    objDivStockError.css({
        'background-color': '#f8d7da',
        'color': '#721c24',
        'padding': blnIsOverview ? '8px 10px' : '10px 15px',
        'border-radius': '5px',
        'border': '1px solid #f5c6cb',
        'margin-top': '10px',
        'font-size': blnIsOverview ? '12px' : '14px',
        'text-align': 'center',
    });

    if (blnIsOverview) {
        objProductCard.find('.stock-error-message').remove();
        objProductCard.append(objDivStockError);
    } else {
        //--Fallback: voeg toe aan het element zelf
        objTargetElement.find('.stock-error-message').remove();
        objTargetElement.append(objDivStockError);
    }

    //--Melding na 4 seconden laten verdwijnen
    setTimeout(function () {
        objDivStockError.fadeOut(300, function () {
            $(this).remove();
        });
    }, 4000);
};

export const sizeCartProgressbar = () => {
    const cartProgressbar = document.getElementById('cartProgressbar');
    const activeCartStep = document.getElementById('activeCartStep');

    if (cartProgressbar && activeCartStep) {
        const positionActiveCartStep = activeCartStep.getBoundingClientRect().x;
        const positionProgressbar = cartProgressbar.getBoundingClientRect().x;
        const widthProgressbar = positionActiveCartStep - positionProgressbar;

        cartProgressbar.style.width = widthProgressbar + 'px';
    }
};

export const cartSubmit = () => {
    const altBtnSubmitCartStep = document.querySelectorAll('[data-target="formCartSubmit"]');
    const btnSubmitCartStep = document.getElementById('btn-submit');

    if (btnSubmitCartStep && altBtnSubmitCartStep.length > 0) {

        altBtnSubmitCartStep.forEach(button => {
            button.addEventListener('click', () => {
                btnSubmitCartStep.click();
            });
        });
    }
};

export const InitAddToCart = () => {
    $('form.add-to-cart').on('submit', function (event) {
        event.preventDefault();

        //--Toevoegen aan winkelmand
        AddToCart($(this));
    });
};

/**
 *    Add item to shopping cart
 */
export const AddToCart = objForm => {
    if (typeof blnAllowCookiesAnalytics === 'undefined') {
        blnAllowCookiesAnalytics = false;
    }

    //--Directe feedback op de geklikte knop (spinner) + dubbelklik-guard; de overlay hieronder blijft als fallback
    if (objForm.data('busy')) {
        return;
    }

    const objButton    = objForm.find('button[type="submit"]');
    const objIcon      = objButton.find('i').first();
    const strIconClass = objIcon.attr('class');

    objForm.data('busy', true);
    objButton.attr('aria-busy', 'true').addClass('pointer-events-none opacity-75');
    objIcon.attr('class', 'fas fa-circle-notch fa-spin fa-lg !mr-0');

    const resetButton = () => {
        objForm.data('busy', false);
        objButton.removeAttr('aria-busy').removeClass('pointer-events-none opacity-75');
        objIcon.attr('class', strIconClass);
    };

    //--Loader pas na een bepaalde tijd tonen
    var objDelay = setTimeout(function () {
        //-- Overlay
        $('div.container-wrapper').css('opacity', '0.3');

        //-- Loader
        $('div.container-wrapper').prepend('<div class=\'filter-loader\'><img src=\'' + strPath + 'images/css/ajax-loader.gif\' alt=\'\' title=\'\' /></div>');
    }, 400);

    $.post(strPath + 'ajax/cart.php', objForm.serialize() + '&lang=' + strLang + '&country=' + strCountry, function (data) {

        //--Replace token
        if (data.token != undefined) {
            $('input[name=\'csrf_token\']').val(data.token);
        }

        if (data.subscription_cart_add_error == true) {
            //$('#subscription-item-add-cart-error').show();
            //--Delay verwijderen
            clearTimeout(objDelay);
            //-- Loader verwijderen
            $('div.container-wrapper').find('div.filter-loader').remove();
            $('div.container-wrapper').css('opacity', '1');
            resetButton();

            var container = $('#cart-popup-error-subscription');
            var old_item_container = container.find('.old-item-cart');
            var new_item_container = container.find('.new-item-cart');

            if (data.old_item.subscription_size == '0') {
                old_item_container.find('.has_dataphone').hide();
            }

            if (data.new_item.subscription_size == '0') {
                new_item_container.find('.has_dataphone').hide();
            }

            old_item_container.find('.cart-articlename').html(data.old_item.articlename);
            old_item_container.find('.cart-planname').html(data.old_item.subscription_plan_name);
            old_item_container.find('.cart-gbdesc').html(data.old_item.subscription_gbdesc);
            old_item_container.find('.cart-featuredesc').html(data.old_item.subscription_featuredesc);
            old_item_container.find('input[name="item"]').val(data.old_item.articleno + '/' + data.old_item.subscriptionId + '/' + data.old_item.subscriptionPlanId + '/' + data.old_item.subscriptionPrice);

            new_item_container.find('.cart-articlename').html(data.new_item.articlename);
            new_item_container.find('.cart-planname').html(data.new_item.subscription_plan_name);
            new_item_container.find('.cart-gbdesc').html(data.new_item.subscription_gbdesc);
            new_item_container.find('.cart-featuredesc').html(data.new_item.subscription_featuredesc);
            new_item_container.find('input[name="item"]').val(data.new_item.articleno + '/' + data.new_item.subscriptionId + '/' + data.new_item.subscriptionPlanId + '/' + data.new_item.subscriptionPrice);

            $('#cart-popup-error-subscription-link').trigger('click');
        } else if (data.error == true) {
            //--Stock error - niet genoeg voorraad
            clearTimeout(objDelay);
            $('div.container-wrapper').find('div.filter-loader').remove();
            $('div.container-wrapper').css('opacity', '1');
            resetButton();
            showStockError(data.message, objForm);
        } else if (data != '') {
            try {
                rrApi.addToBasket($('input[name=\'articleno\']', objForm).val());
            } catch (e) {
            }

            dataLayer.push({
                'event': 'add-to-cart',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {                                // 'add' actionFieldObject measures.
                        'products': [{                        //  adding a product to a shopping cart.
                            'name': data.name,
                            'id': data.alias,
                            'price': String(data.price),
                            'brand': data.brand,
                            'category': '',
                            'variant': '',
                            'quantity': data.quantity,
                        }],
                    },
                },
            });

            //--Klaviyo - Added to Cart
            if (typeof _learnq !== 'undefined') {
                _learnq.push(['track', 'Added to Cart', {
                    'ProductName': data.name,
                    'ProductID': data.alias,
                    'SKU': data.articleno,
                    'Price': parseFloat(data.price),
                    'Brand': data.brand,
                    'Quantity': parseInt(data.quantity),
                    'ImageURL': data.image || '',
                    'Description': data.description || '',
                    'TopSpecs': data.topspecs || '',
                    'CheckoutURL': strPath + 'cart/',
                }]);
            }

            if ($(window).width() > 992) {
                //-- Popup eerst: dit is de response waarop de gebruiker wacht (de mini-cart-call volgt erna,
                //-- zodat die de popup niet vertraagt)
                $.post(strPath + 'ajax/cart-popup.php', objForm.serialize() + '&lang=' + strLang + '&country=' + strCountry, function (data) {

                    //--Delay verwijderen
                    clearTimeout(objDelay);

                    //-- Loader verwijderen
                    $('div.container-wrapper').find('div.filter-loader').remove();
                    $('div.container-wrapper').css('opacity', '1');
                    resetButton();

                    let modalContentContainer = document.getElementById('renderAddToCartContent');
                    modalContentContainer.innerHTML = data;

                    document.getElementById('addToCartModalButton').click();

                    //--Toevoegen aan winkelmandje
                    $('div.product-index div.wrap form.add-to-cart').on('submit', function (event) {
                        event.preventDefault();

                        //--Toevoegen aan winkelmand
                        AddToCart($(this));
                    });
                }, 'html').fail(function () {
                    clearTimeout(objDelay);
                    $('div.container-wrapper').find('div.filter-loader').remove();
                    $('div.container-wrapper').css('opacity', '1');
                    resetButton();
                });

                //--Mini winkelmandje aanpassen (aantal komt uit de cart.php-response, geen extra count-call)
                UpdateMiniCart(data.totalitems, false);
            } else {
                UpdateMiniCart(data.totalitems, false, strHrefWinkelmand);
            }
        }
    }, 'json').fail(function () {
        //--Fout bij toevoegen: overlay en knop herstellen (voorheen bleef de overlay hangen)
        clearTimeout(objDelay);
        $('div.container-wrapper').find('div.filter-loader').remove();
        $('div.container-wrapper').css('opacity', '1');
        resetButton();
    });
};

/**
 *    Add item to shopping cart
 */
export const AddToCartArticleNo = intArticleNo => {
    if (typeof blnAllowCookiesAnalytics === 'undefined') {
        blnAllowCookiesAnalytics = false;
    }

    //--Loader pas na een bepaalde tijd tonen
    var objDelay = setTimeout(function () {
        //-- Overlay
        $('div.container-wrapper').css('opacity', '0.3');

        //-- Loader
        $('div.container-wrapper').prepend('<div class=\'filter-loader\'><img src=\'' + strPath + 'images/css/ajax-loader.gif\' alt=\'\' title=\'\' /></div>');
    }, 400);

    $.post(strPath + 'ajax/cart.php', 'articleno=' + intArticleNo + '&product-type=tweakwise&lang=' + strLang + '&country=' + strCountry, function (data) {
        //--Replace token
        if (data.token != undefined) {
            $('input[name=\'csrf_token\']').val(data.token);
        }

        if (data.error == true) {
            //--Stock error - niet genoeg voorraad
            clearTimeout(objDelay);
            $('div.container-wrapper').find('div.filter-loader').remove();
            $('div.container-wrapper').css('opacity', '1');

            //--Zoek het product element op basis van artikelnummer
            var objProductElement = $('[data-articleno="' + intArticleNo + '"]').closest('.product-item, .product-index, .card');
            if (objProductElement.length === 0) {
                objProductElement = $('input[name="articleno"][value="' + intArticleNo + '"]').closest('form');
            }
            if (objProductElement.length === 0) {
                objProductElement = $('div.container-wrapper');
            }
            showStockError(data.message, objProductElement);
        } else if (data != '') {
            dataLayer.push({
                'event': 'add-to-cart',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {                                // 'add' actionFieldObject measures.
                        'products': [{                        //  adding a product to a shopping cart.
                            'name': data.name,
                            'id': data.alias,
                            'price': String(data.price),
                            'brand': data.brand,
                            'category': '',
                            'variant': '',
                            'quantity': data.quantity,
                        }],
                    },
                },
            });

            //--Klaviyo - Added to Cart
            if (typeof _learnq !== 'undefined') {
                _learnq.push(['track', 'Added to Cart', {
                    'ProductName': data.name,
                    'ProductID': data.alias,
                    'SKU': data.articleno,
                    'Price': parseFloat(data.price),
                    'Brand': data.brand,
                    'Quantity': parseInt(data.quantity),
                    'ImageURL': data.image || '',
                    'Description': data.description || '',
                    'TopSpecs': data.topspecs || '',
                    'CheckoutURL': strPath + 'cart/',
                }]);
            }

            if ($(window).width() > 992) {
                //--Mini winkelmandje aanpassen
                UpdateMiniCart(data.totalitems, false);

                //-- Popup
                $.post(strPath + 'ajax/cart-popup.php', 'articleno=' + intArticleNo + '&lang=' + strLang + '&country=' + strCountry, function (data) {
                    //--Delay verwijderen
                    clearTimeout(objDelay);

                    //-- Loader verwijderen
                    $('div.container-wrapper').find('div.filter-loader').remove();
                    $('div.container-wrapper').css('opacity', '1');

                    let modalContentContainer = document.getElementById('renderAddToCartContent');
                    modalContentContainer.innerHTML = data;

                    document.getElementById('addToCartModalButton').click();

                    //--Toevoegen aan winkelmandje
                    $('div.product-index div.wrap form.add-to-cart').on('submit', function (event) {
                        event.preventDefault();

                        //--Toevoegen aan winkelmand
                        AddToCart($(this));
                    });
                }, 'html');
            } else {
                UpdateMiniCart(data.totalitems, false, strHrefWinkelmand);
            }
        }
    }, 'json');
};

/**
 *    Add item to shopping cart
 */
export const AddToCartArticleAlias = (intArticleAlias, strRedirect) => {
    if (typeof blnAllowCookiesAnalytics === 'undefined') {
        blnAllowCookiesAnalytics = false;
    }

    //--Loader pas na een bepaalde tijd tonen
    var objDelay = setTimeout(function () {
        //-- Overlay
        $('div.container-wrapper').css('opacity', '0.3');

        //-- Loader
        $('div.container-wrapper').prepend('<div class=\'filter-loader\'><img src=\'' + strPath + 'images/css/ajax-loader.gif\' alt=\'\' title=\'\' /></div>');
    }, 400);

    $.post(strPath + 'ajax/cart.php', 'articlealias=' + intArticleAlias + '&product-type=zoovu&lang=' + strLang + '&country=' + strCountry, function (data) {
        //--Replace token
        if (data.token != undefined) {
            $('input[name=\'csrf_token\']').val(data.token);
        }

        if (data.error == true) {
            //--Stock error - niet genoeg voorraad
            clearTimeout(objDelay);
            $('div.container-wrapper').find('div.filter-loader').remove();
            $('div.container-wrapper').css('opacity', '1');

            //--Zoek het product element op basis van artikelalias
            var objProductElement = $('[data-articlealias="' + intArticleAlias + '"]').closest('.product-item, .product-index, .card');
            if (objProductElement.length === 0) {
                objProductElement = $('input[name="articlealias"][value="' + intArticleAlias + '"]').closest('form');
            }
            if (objProductElement.length === 0) {
                objProductElement = $('div.container-wrapper');
            }
            showStockError(data.message, objProductElement);
        } else if (data != '') {
            dataLayer.push({
                'event': 'add-to-cart',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {                                // 'add' actionFieldObject measures.
                        'products': [{                        //  adding a product to a shopping cart.
                            'name': data.name,
                            'id': data.alias,
                            'price': String(data.price),
                            'brand': data.brand,
                            'category': '',
                            'variant': '',
                            'quantity': data.quantity,
                        }],
                    },
                },
            });

            //--Klaviyo - Added to Cart
            if (typeof _learnq !== 'undefined') {
                _learnq.push(['track', 'Added to Cart', {
                    'ProductName': data.name,
                    'ProductID': data.alias,
                    'SKU': data.articleno,
                    'Price': parseFloat(data.price),
                    'Brand': data.brand,
                    'Quantity': parseInt(data.quantity),
                    'ImageURL': data.image || '',
                    'Description': data.description || '',
                    'TopSpecs': data.topspecs || '',
                    'CheckoutURL': strPath + 'cart/',
                }]);
            }

            if (strRedirect != '') {
                window.location = strRedirect;
            }
        }
    }, 'json');
};

/**
 *    Update cart (in cart-table)
 */
export const UpdateCart = objForm => {
    $.post(strPath + 'ajax/cart.php', objForm.serialize() + '&lang=' + strLang + '&country=' + strCountry, function (data) {
        if (data != '') {
            //--Replace token
            if (data.token != undefined) {
                $('input[name=\'csrf_token\']').val(data.token);
            }

            UpdateMiniCart(data.totalitems, data.reload);
        }
    }, 'json');
};

/**
 *    Update cart (in cart-table)
 */
export const UpdateMiniCart = (intTotalItems, blnReload, strLocation) => {
    if (blnReload == undefined) {
        blnReload = false;
    }

    //--Save total to session storage en header-bubble direct bijwerken
    SetSessionStorage('intTotalArticlesCart', intTotalItems);
    SetCartBubble(intTotalItems);

    //--Reload page
    if (blnReload === true) {
        document.location.reload();
    } else {
        GetMiniCart();
        //--count-cart.php enkel als de caller geen aantal kon meegeven
        if (intTotalItems === undefined || intTotalItems === null) {
            CountCart();
        }
        RefreshCartContent('both');
    }

    //--Go to location
    if (strLocation != undefined) {
        document.location = strLocation;
    }
};

/**
 *    Update quantity in cart
 */
export const CartUpdateCart = (objInput, blnCheckStock) => {
    if (typeof blnCheckStock === 'undefined') {
        blnCheckStock = false;
    }

    //-- Ensure that there are no decimal numbers added (if necessary)
    objInput.val(Math.ceil(objInput.val()));

    var objForm = objInput.parents('form:first');

    if (blnCheckStock) {
        //-- Check stock (if needed)
        var strQtyId = objInput.attr('id');
        var strSelQtyId = strQtyId.replace('qty', 'selQty');
        var strOldQtyId = strQtyId.replace('qty', 'hdnOldQty');
        $.post(strPath + 'ajax/check-stock.php', strQtyId + '=' + objInput.val() + '&' + 'type=cart&lang=' + strLang + '&country=' + strCountry, function (data) {
            data = eval('(' + data + ')');

            if (data.value == 1) {
                //-- To remember the original quantity
                $('#' + strOldQtyId).val(objInput.val());
                $('div.stock-error').slideUp('fast');

                //-- Update cart
                UpdateCart(objForm);
            } else {
                //-- Show error
                $('div.stock-error').text(data.message);
                $('div.stock-error').slideDown('fast');
                $('#' + strQtyId).val($('#' + strOldQtyId).val());
                $('#' + strSelQtyId).val($('#' + strOldQtyId).val());
            }

            return false;
        });
    } else {
        UpdateCart(objForm);
    }
};

export function loadMiniCart() {
    $('#cartMiniBtn').on('mouseenter', function () {
        $('div#mini-cart-dropdown div.wrap').html('<div class=\'mini-cart-loader\'><img src=\'' + strPath + 'images/css/ajax-loader.gif\' alt=\'\' title=\'\' /></div>');

        GetMiniCart();
    });
}

export function GetMiniCart() {
    $.get(strPath + 'ajax/cart-mini.php', 'lang=' + strLang + '&country=' + strCountry, function (data) {
        if (data != '') {
            const miniCartContainer = document.getElementById('mini-cart-dropdown');
            $(miniCartContainer).html(data);
            //-- Re-initialize supermenu so you can close the menu
            InitSuperMenu('#mini-cart-dropdown [data-action=\'toggle-slide-left\']');

            //-- Remove the item from the cart
            $(miniCartContainer).find('a.delete').on('click', function () {
                RemoveFromCart($(this).attr('data-delete'), false, true);
            });

            InitIncrementCart(false, miniCartContainer);
            //loadMiniCartForExitIntent();
        }
    }, 'html');
}

/**
 *    Remove item from cart
 */
export const RemoveFromCart = (strParams, blnReload, blnMiniCart, blnExitIntent = false) => {
    if (blnReload == undefined) {
        blnReload = true;
    }

    if (blnMiniCart == undefined) {
        blnMiniCart = false;
    }

    // if action is triggered by exit intent, remove exit intent shown from session storage
    if (blnExitIntent) {
        sessionStorage.removeItem('exitIntentShown');
    }

    var explode = strParams.split('_');
    var strParams = 'params=' + strParams + '&cart-type=delete&lang=' + strLang + '&country=' + strCountry + '&csrf_token=' + $('input[name=\'csrf_token\']').val();

    if (blnExitIntent) {
        strParams += '&csrf_token_exit_intent=' + $('input[name=\'csrf_token_exit_intent\']').val();
    } else if (blnMiniCart) {
        strParams += '&csrf_token_cart=' + $('input[name=\'csrf_token_cart\']').val();
    }
    $.post(strPath + 'ajax/cart.php', strParams, function (data) {
        if (data != '') {
            //--Replace token
            if (data.token != undefined) {
                $('input[name=\'csrf_token\']').val(data.token);
            }

            dataLayer.push({
                'event': 'removeFromCart',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'remove': {                                // 'add' actionFieldObject measures.
                        'products': [{                        //  adding a product to a shopping cart.
                            'name': data.name,
                            'id': data.alias,
                            'price': String(data.price),
                            'brand': data.brand,
                            'category': '',
                            'variant': '',
                            'quantity': data.quantity,
                        }],
                    },
                },
            });

            UpdateMiniCart(data.totalitems, blnReload);
        }
    }, 'json');
};

/**
 *    Empty cart
 */
export const EmptyCart = () => {
    SetSessionStorage('intTotalArticlesCart', 0);
};

/**
 *    Add discount code
 */
export const AddDiscountCode = () => {
    //-- After entering a discount code
    $('.txtDiscountCode').on('blur', function () {
        //-- Validate discount code
        var strParams = 'type=add&addressno=' + intAddressno + '&discountcode=' + $(this).val() + '&lang=' + strLang + '&country=' + strCountry;
        $.post(strPath + 'ajax/discount.php', strParams, function (arrObjecten) {

            $('.discountcode-error').slideUp(EffectSpeed);
            if (arrObjecten.value == 0) {
                if (arrObjecten.popuplogin) {
                    //-- Show popup login (if gift card and not logged in)
                    var objALogin = $('<a href="' + arrObjecten.message + '" class="popuplogin"></a>');
                    // $('form#frmDiscount').append(objALogin);
                    //-- Open 'Product added' popup
                    // objALogin.fancybox({
                    //     helpers: {
                    //         overlay: {
                    //             locked: false,
                    //         },
                    //     },
                    //     width: 420,
                    //     height: 550,
                    //     autoSize: false,
                    //     transitionIn: 'none',
                    //     transitionOut: 'none',
                    //     type: 'iframe',
                    // });
                    objALogin.trigger('click');
                } else {
                    //-- Error
                    $('.discountcode-error').html(arrObjecten.message);
                    $('.discountcode-error').slideDown(EffectSpeed).show();
                }
            } else if (arrObjecten.value == 1) {
                //-- Correct code => reload page
                document.location.reload();
            }
        }, 'json');
    });

    $('.txtDiscountCode').on('keypress', function (e) {
        if (e.which === 13) {
            $(this).trigger('blur');
            return false;
        }
    });

    $('[data-target="add-discount-code"]').on('click', function () {
        $('.add-discount-form').toggleClass('hidden');
        $(this).toggleClass('hidden');
    });

    $('.toggle-arrow').on('click', function () {
        $(this).find('i[class*="fa-angle"]').toggleClass('fa-flip-vertical');
    });
};

/**
 *    Remove discount code
 */
export const RemoveDiscountCode = () => {
    //-- Click on 'remove discount code'
    $('a[id^=remove-discount]').on('click', function () {
        //-- Remove discount code
        var arrDiscountno = $(this).attr('id').split('-');
        var strParams = 'type=delete&discountno=' + arrDiscountno[2] + '&lang=' + strLang + '&country=' + strCountry;
        $.post(strPath + 'ajax/discount.php', strParams, function (arrObjecten) {

            $('.discountcode-error').slideUp(EffectSpeed);
            if (arrObjecten.value == 0) {
                //-- Error
                $('.discountcode-error p').text(html_entity_decode(arrObjecten.message));
                $('.discountcode-error').slideDown(EffectSpeed);
            } else if (arrObjecten.value == 1) {
                //-- Right code => reload page
                document.location.reload();
            }

        }, 'json');
    });
};


/**
 *    Add giftcard code
 */
export const AddGiftCardCode = () => {

    //-- After entering a gift card code
    $('input#txtGiftcardCode').on('blur', function () {
        //-- Validate
        if ($(this).val()) {
            //-- Check if it's a valid gift card code and if valid, save the gift card code in session
            var strParams = 'strAction=add&intAddressno=' + intAddressno + '&strGiftCardCode=' + $(this).val() + '&lang=' + strLang + '&country=' + strCountry;
            $.post(strPath + 'ajax/giftcard.php', strParams, function (arrObjecten) {
                //-- Remove previous errors
                $('li#gift-cart-error').remove();
                if (arrObjecten.value == 0) {
                    //-- Error
                    var objLi = $('<li id=\'gift-cart-error\'></li>');
                    var objDivBoxInfo = $('<div class=\'box-error\'></div>');
                    objDivBoxInfo.html('<p>' + arrObjecten.message + '</p>');
                    objLi.append(objDivBoxInfo);
                    $('ul#gift-card-form').append(objLi);
                } else if (arrObjecten.value == 1) {
                    //-- Correct code => reload page
                    document.location.reload();
                }
            }, 'json');
        }
    });

    //-- When clicking on button 'Add' (and not filled in the gift card code)
    $('ul#gift-card-form #btnAddGiftCard').on('click', function () {
        if ($('input#txtGiftcardCode').val() == '') {
            $('li#gift-cart-error').remove();

            if (typeof strLabelGiftCardNotValid !== 'undefined') {
                var objLi = $('<li id=\'gift-cart-error\'></li>');
                var objDivBoxInfo = $('<div class=\'box-error\'></div>');
                objDivBoxInfo.html('<p>' + strLabelGiftCardNotValid + '</p>');
                objLi.append(objDivBoxInfo);
                $('ul#gift-card-form').append(objLi);
            }
        }
    });

    /*//-- After entering a gift card code
    $("input#txtGiftcardCode").on('blur', function () {
        $("ul#gift-card-form #btnAddGiftCard").trigger('click');
    });*/

    //-- If enter in gift card code field
    $('input#txtGiftcardCode').on('keypress', function (e) {
        if (e.which == 13) {
            $(this).trigger('blur');
            return false;
        }
    });
};

/**
 *    Remove giftcard code
 */
export const RemoveGiftCardCode = () => {
    $('a.remove-giftcard').on('click', function () {
        var arrGiftcardno = $(this).attr('id').split('-');
        var strParams = 'strAction=delete&intGiftCardNo=' + arrGiftcardno[2];
        $.post(strPath + 'ajax/giftcard.php', strParams + '&lang=' + strLang + '&country=' + strCountry, function (arrObjecten) {
            //-- Remove previous errors
            $('div#gift-card-error').remove();
            if (arrObjecten.value == 0) {
                //-- Error
                var objDivError = $('<div class=\'box-info error\' id=\'gift-card-error\'></div>');
                objDivError.text(arrObjecten.message);
                $('div#giftcard-added table').after(objDivError);
            } else if (arrObjecten.value == 1) {
                //-- Right code => reload page
                document.location.reload();
            }
        }, 'json');

        return false;
    });
};


// Event delegation voor cart increment knoppen - werkt ook na AJAX refresh
// Wordt één keer aangeroepen bij page load
let cartIncrementDelegationInitialized = false;

export function InitCartIncrementDelegation() {
    if (cartIncrementDelegationInitialized) {
        return; // Al geïnitialiseerd
    }
    cartIncrementDelegationInitialized = true;

    // Document-level event delegation - werkt altijd, ook na AJAX
    $(document).on('click', '.cart-wrapper [data-toggle="increment"]', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const targetId = $(this).attr('data-tw-target');
        const targetInput = document.getElementById(targetId);

        getDataUpdateCart(
            targetInput,
            targetId,
            false,
            true,
            this
        );
    });
}

export function getDataUpdateCart(targetInput, targetId, blnCheckStock, isBtn, currentTarget = event) {
    // Fallback als targetInput null is
    if (!targetInput) {
        targetInput = document.getElementById(targetId);
    }
    if (!targetInput) {
        return;
    }

    // Disable knoppen - de input en buttons zitten in dezelfde parent div
    const buttonContainer = targetInput.parentElement;
    if (buttonContainer) {
        buttonContainer.querySelectorAll('[data-toggle="increment"]').forEach(btn => {
            btn.disabled = true;
            btn.classList.add('opacity-50', 'pointer-events-none');
        });
        targetInput.disabled = true;
        targetInput.style.backgroundColor = 'white';
    }

    let inputValue = parseInt(targetInput.value);
    inputValue = isNaN(inputValue) ? 1 : inputValue;

    let myArray = targetId.split('_');
    myArray.shift();

    if (isBtn) {
        let isIncrement = currentTarget.getAttribute('data-action') === 'increment';
        isIncrement ? inputValue++ : inputValue--;
    }

    let objInput = $(`input[id^=qty_${myArray[0]}_${myArray[1]}]`);
    objInput.val(inputValue);

    let strParams = "intQuantity=" + inputValue;
    strParams += "&intArticleNo=" + myArray[0];


    $.post(strPath + 'ajax/check-stock.php', strParams + '&lang=' + strLang + '&country=' + strCountry, function (data) {
        if (data.value == 0) {
            // Not enough stock => show error (vervang bestaande melding i.p.v. stapelen)
            $('form#shoppingcart').find('.js-stock-error').remove();
            var objDivStockError = $('<div class=\'box-error mb-2 js-stock-error\'></div>');
            objDivStockError.html(data.message);
            $('form#shoppingcart').prepend(objDivStockError);

            // Change quantity to quantity on stock
            inputValue = data.stock;
            objInput.val(inputValue);

            // No stock -> hide row
            if (inputValue == 0) {
                objInput.closest('tr').addClass('hidden');
            }

            // Update cart
            setTimeout(function () {
                CartUpdateCart(objInput, blnCheckStock);
            }, 3000);
        } else {
            // Update cart
            CartUpdateCart(objInput, blnCheckStock);
        }
    }, "json");

    targetInput.value = inputValue;
}


export function InitIncrementCart(blnCheckStock, container = document, blnExitIntent = false) {
    const incrementContainer = getContainer(container);

    const incrementButtons = incrementContainer.querySelectorAll('[data-toggle="increment"]');
    const incrementInputs = incrementContainer.querySelectorAll('[data-quantity]');

    if (incrementInputs) {
        incrementInputs.forEach(input => {
            // Sla originele waarde op voor blur check
            input.dataset.originalValue = input.value;

            ['keypress', 'keydown'].forEach(listener => input.addEventListener(listener, (event) => {
                event.stopPropagation();

                // if action is triggered by exit intent, remove exit intent shown from session storage
                if (blnExitIntent) {
                    sessionStorage.removeItem('exitIntentShown');
                }

                if (event.key === 'Enter') {
                    event.preventDefault();

                    getDataUpdateCart(
                        event.currentTarget,
                        event.currentTarget.id,
                        blnCheckStock,
                        false,
                    );
                }

                return false;
            }));

            // Blur event - wanneer je uit het veld gaat
            input.addEventListener('blur', (event) => {
                const currentVal = event.currentTarget.value;
                const originalVal = event.currentTarget.dataset.originalValue;

                // Alleen updaten als waarde is gewijzigd
                if (currentVal !== originalVal) {
                    // if action is triggered by exit intent, remove exit intent shown from session storage
                    if (blnExitIntent) {
                        sessionStorage.removeItem('exitIntentShown');
                    }

                    getDataUpdateCart(
                        event.currentTarget,
                        event.currentTarget.id,
                        blnCheckStock,
                        false,
                    );
                }
            });
        });
    }

    if (incrementButtons) {
        incrementButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.stopPropagation();

                // if action is triggered by exit intent, remove exit intent shown from session storage
                if (blnExitIntent) {
                    sessionStorage.removeItem('exitIntentShown');
                }

                getDataUpdateCart(
                    document.getElementById(event.currentTarget.getAttribute('data-tw-target')),
                    event.currentTarget.getAttribute('data-tw-target'),
                    blnCheckStock,
                    true,
                    event.currentTarget,
                );
            });
        });
    }
};

export let cartCount = 0;

/**
 *    Header-bubble met aantal artikelen bijwerken
 */
export function SetCartBubble(intCount) {
    cartCount = parseInt(intCount, 10) || 0;
    const bubble = $('div.mini-cart small.bubble');

    bubble.text(cartCount);
    bubble.toggleClass('hidden', cartCount <= 0);
}

export function CountCart() {
    $.post(strPath + 'ajax/count-cart.php', 'lang=' + strLang + '&country=' + strCountry, function (data) {
        SetCartBubble(data);
    });
}

export function SaveAndReloadMiniCart(strParams = "") {
    //--Template bepalen
    var strTemplate = "cart-table-small";
    if ($('div.' + strTemplate).length === 0) {
        strTemplate = "cart-table-right";
    }
    const strBaseParams = strParams + '&template=' + strTemplate + '&output=html&lang=' + strLang + '&country=' + strCountry;

    if (strTemplate == "cart-table-small") {
        //--Het kleine cart-blok kan meerdere keren op de pagina staan (checkout stap 4/5: mobiel + desktop-sidebar),
        //--elk met een eigen modal-suffix zodat label- en modal-ids uniek blijven. Daarom per instantie verversen
        //--en enkel dát element vervangen: één gedeelde response gaf beide blokken dezelfde ids, waarna de switches
        //--en info-modals in het tweede (zichtbare desktop-)blok niet meer reageerden.
        //--De init-functies draaien pas één keer als alle instanties vervangen zijn (cartSubmit e.d. binden zonder guard).
        const arrRequests = $('div.' + strTemplate).map(function () {
            const $instance = $(this);
            const strModalSuffix = $instance.data('modal-suffix') || '';
            return $.post(strPath + 'ajax/cart-refresh.php', strBaseParams + '&modalsuffix=' + encodeURIComponent(strModalSuffix), function (objResponse) {
                $instance.replaceWith(objResponse);
            }, 'html');
        }).get();

        $.when.apply($, arrRequests).always(function () {
            cartSubmit();
            InitCollapse('div.cart-table-small');
            InitSwitches();
            InitModals();
            InitTooltips();
            InitDataHref();
        });
        return;
    }

    $.post(strPath + 'ajax/cart-refresh.php', strBaseParams, function (objResponse) {
        $('div.' + strTemplate).replaceWith(objResponse);
        const proceedButton = document.querySelectorAll('[data-toggle="proceed"]');

        if (proceedButton) {
            proceedButton.forEach(button => {
                button.addEventListener('click', () => {
                    $('form.frm-cart-proceed').trigger('submit');
                });
            });
        }
    }, 'html');
}

export function RefreshCartContent(parts = 'both') {
    // Alleen AJAX call doen als we op de winkelmandpagina zijn
    const cartWrapper = document.querySelector('.cart-wrapper');
    const cartRight = document.querySelector('div.cart-table-right');

    if (!cartWrapper && !cartRight) {
        return;
    }

    $.post(strPath + 'ajax/cart-refresh.php', 'parts=' + parts + '&output=json&lang=' + strLang + '&country=' + strCountry, function (response) {
        // Als de cart leeg is, pagina herladen
        if (response.cartCount === 0) {
            document.location.reload();
            return;
        }

        // Update linkerkant
        if (response.cartTable && cartWrapper) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = response.cartTable;
            const newCartWrapper = tempDiv.querySelector('.cart-wrapper');
            if (newCartWrapper) {
                cartWrapper.innerHTML = newCartWrapper.innerHTML;
            }
        }

        // Update rechterkant
        if (response.cartRight && cartRight) {
            cartRight.outerHTML = response.cartRight;
        }

        // Na ALLES vervangen, opnieuw initialiseren
        reinitCartAfterRefresh();
    }, 'json');
}

// Simpele functie die alles opnieuw initialiseert na AJAX refresh
function reinitCartAfterRefresh() {
    // Increment buttons - gebruik jQuery voor betrouwbare event binding
    $('.cart-wrapper [data-toggle="increment"]').off('click').on('click', function(e) {
        e.stopPropagation();

        // DIRECT hier disablen
        const $container = $(this).parent();
        $container.find('[data-toggle="increment"]').prop('disabled', true).addClass('opacity-50 pointer-events-none');
        $container.find('[data-quantity]').prop('disabled', true).css('background-color', 'white');

        const targetId = $(this).attr('data-tw-target');
        const targetInput = document.getElementById(targetId);
        getDataUpdateCart(targetInput, targetId, false, true, this);
    });

    // Input veld - bij Enter of bij verlaten veld (blur)
    $('.cart-wrapper [data-quantity]').off('keydown blur').on('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            triggerInputUpdate($(this));
        }
    }).on('blur', function() {
        // Check of waarde is gewijzigd
        const currentVal = $(this).val();
        const originalVal = $(this).data('original-value');
        if (currentVal !== originalVal) {
            triggerInputUpdate($(this));
        }
    }).each(function() {
        // Sla originele waarde op
        $(this).data('original-value', $(this).val());
    });

    function triggerInputUpdate($input) {
        // Disable knoppen
        const $container = $input.parent();
        $container.find('[data-toggle="increment"]').prop('disabled', true).addClass('opacity-50 pointer-events-none');
        $input.prop('disabled', true).css('background-color', 'white');

        const targetInput = $input[0];
        const targetId = $input.attr('id');
        getDataUpdateCart(targetInput, targetId, false, false, targetInput);
    }

    // Delete buttons
    $('.cart-wrapper a.delete').off('click').on('click', function(e) {
        e.preventDefault();
        RemoveFromCart($(this).attr('data-delete'), true, false);
    });

    // Overige componenten
    InitTooltips();
    InitModals();
    InitSwitches();
    InitCollapse('.cart-wrapper');
    InitCollapse('div.cart-table-right');
    InitDataHref();

    // Proceed buttons
    $('[data-toggle="proceed"]').off('click').on('click', function() {
        $('form.frm-cart-proceed').trigger('submit');
    });
}